import React from "react";

import * as S from "./Dim.style";

interface Props {
  children: React.ReactNode;
}

const Dim = ({ children }: Props) => {
  return <S.Dim>{children}</S.Dim>;
};

export default Dim;
